'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (diff) {
  var isOneAdded = diff.added.length === 1 && (diff.added.indexOf('classification') > -1 || diff.added.indexOf('subclassification') > -1);
  var isOneUpdated = diff.updated.length === 1 && (diff.updated.indexOf('classification') > -1 || diff.updated.indexOf('subclassification') > -1);
  var isOneDeleted = diff.deleted.length === 1 && (diff.deleted.indexOf('classification') > -1 || diff.deleted.indexOf('subclassification') > -1);

  var isBothAdded = diff.added.length === 2 && diff.added.indexOf('classification') > -1 && diff.added.indexOf('subclassification') > -1;
  var isBothUpdated = diff.updated.length === 2 && diff.updated.indexOf('classification') > -1 && diff.updated.indexOf('subclassification') > -1;
  var isBothDeleted = diff.deleted.length === 2 && diff.deleted.indexOf('classification') > -1 && diff.deleted.indexOf('subclassification') > -1;

  return isOneAdded || isOneUpdated || isOneDeleted || isBothAdded || isBothUpdated || isBothDeleted;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/classification-counts-need-updating/only-classifications-changed.js
 ** module id = 471
 ** module chunks = 0
 **/